import { render } from "./CollectTable.vue?vue&type=template&id=3c4b7f98"
import script from "./CollectTable.vue?vue&type=script&lang=js"
export * from "./CollectTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__